__webpack_require__.p = "/dev/924-definir-les-donnees-en-dur-a-un-seul-endroit/";